<template>
  <div id="gallery-page">
    <div class="container oversized-container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <h1 class="common-title pt-2 pb-4">{{ $t("shared.titles.gallery") }}</h1>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-lg-4 col-project-sample" v-for="(image, imageIndex) in videos" :key="imageIndex">
          <a class="pj-link" @click="setIndex(imageIndex)">
            <div class="placed-backg box-img" v-bind:style="{ backgroundImage: 'url('+image.videoLinkFancyBox+')' }">
              <img src="public/images/shared/article.png">
            </div>
            <div class="box-info">
              <h5>{{ image.title }}</h5>
            </div>
          </a>
        </div>
      </div>
    </div>

    <CoolLightBox
      :items="videos"
      :index="index"
      loop
      @close="index = null">
    </CoolLightBox>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  components: {
    CoolLightBox,
  },

  data() {
    return {
      items: [
        {
          title: "Video 01",
          src: 'public/images/shared/person-1.jpg',
          videoLinkFancyBox: 'public/images/pages/video/01_000.jpg',
        },
        {
          title: "Video 02",
          src: 'public/videos/01.mp4',
          videoLinkFancyBox: 'public/images/pages/video/01_000.jpg',
        },
      ],
      index: null,

      videos: [
        { src: "public/videos/01.mp4", videoLinkFancyBox: "public/images/pages/video/01_000.jpg", title: "Video 01" },
        { src: "public/videos/02.mp4", videoLinkFancyBox: "public/images/pages/video/02_000.jpg", title: "Video 02" },
        { src: "public/videos/03.mp4", videoLinkFancyBox: "public/images/pages/video/03_000.jpg", title: "Video 03" },
        { src: "public/videos/04.mp4", videoLinkFancyBox: "public/images/pages/video/04_000.jpg", title: "Video 04" },
        { src: "public/videos/05.mp4", videoLinkFancyBox: "public/images/pages/video/05_000.jpg", title: "Video 05" },
        { src: "public/videos/06.mp4", videoLinkFancyBox: "public/images/pages/video/06_000.jpg", title: "Video 06" },
        { src: "public/videos/07.mp4", videoLinkFancyBox: "public/images/pages/video/07_000.jpg", title: "Video 07" },
        { src: "public/videos/08.mp4", videoLinkFancyBox: "public/images/pages/video/08_000.jpg", title: "Video 08" },
        { src: "public/videos/09.mp4", videoLinkFancyBox: "public/images/pages/video/09_000.jpg", title: "Video 09" },
        { src: "public/videos/10.mp4", videoLinkFancyBox: "public/images/pages/video/10_000.jpg", title: "Video 10" },
      ],
    };
  },

  methods: {
    setIndex(index) {
      this.index = index
    }
  },
};
</script>

<style>
@media screen and (max-width: 768px) {
    .col-project-sample {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}
</style>
